<template>
    <div id="modalEmailSubmit">
        <div class="modal__body">
            <div class="phone-submit">
                <form action="">
                    <div class="phone-submit__form">
                        <div class="phone-submit__field">
                            <label class="txt-input">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input"
                                           type="text"
                                           placeholder="Код"
                                           :maxlength="4"
                                           v-model="verificationCode">
                                </div>
                                <div class="txt-input__required txt-input__required--error error-block">{{validateCodeTypeText}}</div>
                                <div class="txt-input__required" :class="isValidateErrors ? 'error-block' : 'validated-block'">{{serverResponseText}}</div>
                            </label>
                        </div>
                        <a class="button button--th-main"
                           :class="!isTimerEnd && $v.verificationCode.verificationType ? '' : 'disabled'"
                           v-on:click="changeEmail">Продолжить</a>
                        <a class="button button--th-ctrl" style="background-color: #0078a8; color:white; margin-left: 5px;"
                           v-if="isTimerEnd"
                           v-on:click="reload">Отправить код еще раз</a>
                        <a v-on:click="$emit('close')" class="button button--th-link" data-toggle="collapse" style="margin-left: 5px;">Отменить</a>
                        <div class="phone-submit__timer" v-bind:style="styleObj">
                            <div class="circle-timer" data-circle-timer>
                                <div class="circle-timer__shape">
                                    <svg class="progress" view-box="0 0 100 100" data-circle-timer-progress>
                                        <path class="progress__path progress__path--bg" d="M 42,2 A 39,39 0 1,1 41.9,2"></path>
                                        <path class="progress__path progress__path--load" d="M 42,2 A 39,39 0 1,1 41.9,2" data-circle-timer-shape></path>
                                    </svg>
                                </div>
                                <div class="circle-timer__time" data-circle-timer-time>300</div>
                            </div>
                        </div>
                    </div>
                    <div class="txt-input__message">
                        Мы отправили сообщение вам на почту <span class="data-card__value">{{email}}</span>, следуйте инструкции для подтверждения
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

    const { required } = window.validators
    const { validationMixin, Vuelidate } = window.vuelidate

    export default {
        mixins: [validationMixin],
        props: ['email', 'currentUserName', 'prefix'],
        data: function () {
            return {
                verificationCode: '',
                isValidateErrors: false,
                isTimerEnd: false,
                serverMessage: [],
                serverResponse: '',
                styleObj: { 'visibility': 'visible' }
            }
        },
        created: function () {
        },
        mounted: function () {
            this.initCircleTimer();
        },
        computed: {
            validateCodeTypeText: function () {
                return !this.$v.verificationCode.verificationType || this.verificationCode == '' ? 'Введите четырехзначный код' : ' ';
            },
            serverResponseText: function () {
                return this.serverMessage ? this.serverMessage[0] : '';
            }
        },
        watch: {
            verificationCode: function () {
                if (this.verificationCode.length >= 1) {
                    this.serverMessage = [];
                }
            },
            isValidateErrors: function (isValidateErrors) {
                if (!isValidateErrors) {
                    this.serverMessage = [];
                }
            },
            serverResponse: function (serverResponse) {
                if (serverResponse.isSuccess) {
                    this.email = (this.prefix == '*') ? '' : this.email;
                    this.prefix = '';
                    this.isValidateErrors = false;
                    this.$emit('update', this.email);
                    this.$emit('close')
                } else {
                    this.isValidateErrors = true;
                }

                this.serverMessage = serverResponse.message;
            }
        },
        validations: {
            verificationCode: {
                required: required,
                verificationType: function (value) {
                    return value.match('^[0-9]{4,4}$') ? true : false;
                }
            }
        },
        methods: {
            changeEmail: function () {
                var self = this;
                this.isValidateErrors = false;
                axios.post('/Profiles/ChangeEmail', {
                    CurrentUserName: self.currentUserName,
                    Email: (this.prefix == '*') ? '' : self.email.trim(),
                    VerificationCode: self.verificationCode
                })
                    .then(function (response) {
                        self.serverResponse = response.data;
                    })
                    .catch(function (error) {
                        console.log(error)
                        self.isValidateErrors = true;
                        self.serverMessage = ['Изменение email невозможно, попробуйте позже']
                    });               
            },
            initCircleTimer: function () {
                var self = this;
                self.isTimerEnd = false;
                self.styleObj.visibility = 'visible';

                var timer = new circleTimer(document.querySelector('[data-circle-timer]'), {
                    time: 300000,
                    onEnd: function () {
                        self.isTimerEnd = true;
                        self.styleObj.visibility = 'hidden';
                    }
                });
            },
            reload: function () {
                this.serverMessage = [];
                this.verificationCode = '';
                this.initCircleTimer();
                this.$emit('refresh');
            }
        }
    }

</script>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/ModalEmailVerify.vue